<template>

	
	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

                <div class="row">
                    <div class="col">
                        <div class="row page-header">
                            <div class="col">
                                <h3>Upload Servers <button class="btn btn-success pull-right btn-sm" v-on:click="viewModal" data-toggle="modal" data-target="#addUploadServerModal"><i class="fa fa-plus mr-1"></i> Add Server</button></h3>
                            </div>
                        </div>
                    </div>
                </div>
				
                <div class="row">
                    <div class="col">
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th>Server Id</th>
                                    <th>Location</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="server in servers">
                                    <td>{{ server.server_id }}</td>
                                    <td>{{ server.city }}, {{ server.state }} ({{ server.country }})</td>
                                    <td>
                                        <i data-toggle="tooltip" data-placement="top" title="Approved" class="fa fa-check-circle-o online mr-2" v-if="server.online == true"></i>
                                        <i data-toggle="tooltip" data-placement="top" title="Approved" class="fa fa-check-circle-o offline mr-2" v-if="server.online == false"></i>
                                        {{ server.online | onlineState }}
                                    </td>
                                    <td class="text-right"><button class="btn btn-primary btn-sm"><i class="fa fa-edit"></i></button></td>
                                </tr>
                                <tr v-if="servers.length == 0">
                                    <td colspan="4" class="text-center">No good. Add an upload server ASAP to allow users to upload videos.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

			</div>
		</div>

        <add-upload-server-modal></add-upload-server-modal>

	</div>

			
</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
    import AddUploadServerModal from '../modals/AddUploadServerModal'

	export default {
		name: 'UploadServers',
		data () {
			return {
				servers: {},
			}
        },
        components: {
			'add-upload-server-modal': AddUploadServerModal
		},
        mounted() {
            this.loadServers();
            this.$nextTick(function () {
                EventBus.$on('admin-upload-server-refresh-data', this.loadServers);
            }.bind(this));
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            loadServers() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/servers", this.getAuthorizationHeader()).then((response) => {
                    _this.servers = response.data
                });
            },
            viewModal() {
                EventBus.$emit('admin-upload-server-open-modal');
            },
        },
        filters: {
            onlineState: function(data) {
                if(data) {
                    return 'Online';
                }
                return 'Offline';
            }
        }
	}
</script>

<style scoped>

    .online {
        color: rgba(46, 204, 113,1.0);
    }

    .offline {
        color: rgba(231, 76, 60,1.0);
    }

</style>
